<script lang="ts">
	export let value:number=48;
	let feet:number=Math.floor(value/12);
	let inches:number=value%12;
	
	function change(){
		value=(feet*12) + inches;
	}
	const allowed_feet:number[] = [4,5,6,7];
	const allowed_inches:number[]= [0,1,2,3,4,5,6,7,8,9,10,11];
</script>
<div>
<select name="feet" bind:value={feet} on:change={change}>
	{#each allowed_feet as af}
	<option value={af}>{af} Feet<option>
	{/each}
</select>

<select name="inches" bind:value={inches} on:change={change}>
	{#each allowed_inches as ai}
	<option value={ai}>{ai} Inches</option>
	{/each}
</select>
</div>
<style>
select {
    width: 100%;
    padding: 16px 20px;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: #f8f9fa;
    color: #2c3e50;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    margin-bottom: 8px;
    background-image: url('data:image/svg+xml;utf8,<svg fill="%232c3e50" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: 20px 20px;
    cursor: pointer;
}
select:focus {
    outline: none;
    border-color: #ffd966;
    background: white;
    box-shadow: 0 0 0 3px rgba(255, 217, 102, 0.1);
}
@media (max-width: 600px) {
    select {
        font-size: 1rem;
        padding: 12px 10px;
    }
}
</style>